import { Admin, Resource } from "react-admin";
import authProvider from "./authProvider";
import dataProvider from "./dataProvider";
import { Login } from "react-admin";
import { SpecialtyList } from "./resources/SpecialtyList";
import { SpecialtyEdit } from "./resources/SpecialtyEdit";
import { SpecialtyCreate } from "./resources/SpecialtyCreate";
import { PersonList } from "./resources/PersonList";
import { PersonEdit } from "./resources/PersonEdit";
import { PersonCreate } from "./resources/PersonCreate";
import { WorkList } from "./resources/WorkList";
import { WorkEdit } from "./resources/WorkEdit";
import { WorkCreate } from "./resources/WorkCreate";

export const App = () => (
  <Admin
    dataProvider={dataProvider}
    authProvider={authProvider}
    loginPage={Login}
  >
    <Resource
      name="specialties"
      list={SpecialtyList}
      edit={SpecialtyEdit}
      create={SpecialtyCreate}
    />
    <Resource
      name="people"
      list={PersonList}
      edit={PersonEdit}
      create={PersonCreate}
    />
    {/* --------- Separator --------- */}
    <Resource
      name="works"
      list={WorkList}
      edit={WorkEdit}
      create={WorkCreate}
    />
  </Admin>
);

export default App;
